export default __webpack_public_path__ + "static/media/avatar_162.5919e9e4.png";